import { getExecEndpoint } from '~/api/service/getExecEndpoint';
import { BqResponse } from '~/api/def/endpoints/types';
import { docCompareEndpoint } from '~/api/def/endpoints/docCompare/docCompareEndpoint';

export type DocChatApiType = {
  context1: string;
  context2: string;
  question: string;
};
const endpointDocCompareChatPostExec =
  getExecEndpoint<DocCompareChatEndpointDef>(docCompareEndpoint);
export const docCompareChatEndpointPOST = async (
  payload: DocCompareChatRequest,
) =>
  endpointDocCompareChatPostExec<'POST'>({
    method: 'POST',
    urlExtra: '/chat',
    payload: {
      context1: payload.context1,
      context2: payload.context2,
      question: payload.question,
    },
  });
export const documentCompareChatEndpointOPTIONS = async () =>
  endpointDocCompareChatPostExec<'OPTIONS'>({
    method: 'OPTIONS',
    urlExtra: '/chat',
  });

export interface DocCompareChatEndpointDef {
  endpoint: typeof docCompareEndpoint;
  methods: {
    POST: {
      response: DocCompareChatResponse;
      payload: DocChatApiType;
    };
    OPTIONS: {
      response: DocCompareChatResponse;
    };
  };
}

export interface DocCompareChatRequest {
  context1: string;
  context2: string;
  question: string;
}

type DocCompareChatResponse = BqResponse<{ data: string }>;
